// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1rLJm","notes":"Notes_notes__ZZbqz"};